import React from 'react';

import {
	aquamationContent,
	aquamationTitle,
	differenceContent,
	differenceTitle,
	howDoesContent,
	howDoesTitle,
	videoSrc,
	whatCanContent,
	whatCanTitle,
	whatIsContent,
	whatIsTitle,
} from '@app/components/Pages/Services/Aftercare/Aquamation/AquamationContent';
import CardPhoto from '@app/components/UI/CardPhoto/CardPhoto';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import aftercareAquamation from '@app/images/content/aftercare-aquamation.jpg';
import aquamation from '@app/images/content/aquamation.jpg';

const Aquamation = () => {
	return (
		<HelmetProvider>
			<div>
				<Masthead title={aquamationTitle} imageSrc={aftercareAquamation} />
				<RichText text={aquamationContent} />
				<RichText title={whatIsTitle} text={whatIsContent} />
				<CardPhoto imgURL={aquamation} title={<>&nbsp;</>} />

				<RichText title={howDoesTitle} text={howDoesContent} />
				<RichText title={differenceTitle} text={differenceContent} />
				<RichText title={whatCanTitle} text={whatCanContent} />
				<VideoEmbed videoSrc={videoSrc} />
			</div>
		</HelmetProvider>
	);
};

export default Aquamation;
